// 公示栏

import React, { useEffect, useState } from 'react';
import { RootObject } from '../../type';
import PublicityModal from '../publicityModal/PublicityModal';
import './style.less';


const PublicityFixed = React.memo((props: RootObject["publicity"]) => {

    const {
        inWai,
        winAPprize
    } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [identification, setIdentification] = useState('');

    const showModal = (title: string) => {
        setIsModalOpen(true);
        setIdentification(title);
    };


    const handleCancel = () => {
        setIsModalOpen(false);
        setIdentification('');
    };

    useEffect(() => {
        const footerDom = document.querySelector('.paddle-footer-container') as HTMLDivElement;
        const hoverDom = document.querySelector('.p-p-foundathon-publicity-wrapper') as HTMLDivElement;
        const scrollListenr = () => requestAnimationFrame(() => {
            if (footerDom && hoverDom) {
                const footerDomTop = footerDom.getBoundingClientRect().top;
                if (footerDomTop < 738) {
                    hoverDom.style.position = 'absolute';
                    hoverDom.style.top = 'auto';
                    hoverDom.style.bottom = '0';
                }
                else {

                    // popoverDom.style.position = 'fixed';
                    hoverDom.style.position = 'fixed';
                    hoverDom.style.bottom = 'auto';
                    hoverDom.style.top = '66%';
                }
            }
        });

        window.addEventListener('scroll', scrollListenr, false);
        return () => {
            window.removeEventListener('scroll', scrollListenr);
        }
    }, []);

    return (
        <div className='p-p-foundathon-publicity-wrapper'>
            <div className='qr-code-popover qr-code-popover-register' onClick={() => showModal('入围公示')}>
                <span className='qr-code-icon register-now' />
                <div className='qr-code-name'>
                    <div className='qr-code-name-t'>入围</div>
                    <div className='qr-code-name-b'>公示</div>
                </div>
            </div>

            <div className='qr-code-popover' onClick={() => showModal('获奖公示')}>
                <span className='qr-code-icon' />
                <div className='qr-code-name'>
                    <div className='qr-code-name-t'>获奖</div>
                    <div className='qr-code-name-b'>公示</div>
                </div>
            </div>
            <PublicityModal
                handleCancel={handleCancel}
                isModalOpen={isModalOpen}
                identification={identification}
                inWai={inWai}
                winAPprize={winAPprize}
            />
        </div>
    )
});

export default PublicityFixed;